import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const ForgotPassword = ({ forgotPassword, setForgotPassword, existingUsername, socket }) => {

    const [username, setUsername] = useState(existingUsername);

    const [otp, setOtp] = useState({
        fetch: false,
    });

    const [pin, setPin] = useState(null);

    const [userId, setUserId] = useState(null);

    const [showOtp, setShowOtp] = useState(false);

    const [showChangePW, setShowChangePW] = useState(false);

    const [pw, setPw] = useState({
        password: '',
        password2: ''
    });

    const mismatch = pw.password !== '' && pw.password2 !== '' && pw.password !== pw.password2;

    useEffect(() => {
        if (otp.fetch) {
            socket.emit("fetch otp", username);
            socket.on('otp completed', () => {
                setShowOtp(true);
                setOtp({ ...otp, fetch: false });
            });
        }
    }, [socket, otp, username]);

    const handleSubPin = () => {
        let payload = {
            username,
            pin
        }
        socket.emit('send otp', payload);
        socket.on('otp correct', data => {
            if (data.state === 'success') {
                setPin(data.token);
                setUserId(data.id);
                setShowOtp(false);
                setShowChangePW(true);
            }
        });
    }

    const handleChangePassword = () => {
        let payload = {
            username,
            userId,
            pin,
            password: pw.password
        }
        socket.emit('change password', payload);
        socket.on('password changed', () => {
            setShowChangePW(false);
        });
    }

    return (
        <>
            <Dialog open={forgotPassword} onClose={() => setForgotPassword(false)} fullWidth maxWidth="xs">
                <DialogTitle>Forgot Password</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <TextField
                            label="Callsign"
                            value={username}
                            onChange={e => setUsername(e.target.value.toUpperCase())}
                            required
                            fullWidth
                        />
                        <DialogContentText>
                            Please enter your callsign and a One Time Pin will be sent to the email address on file.
                        </DialogContentText>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => { setForgotPassword(false); setShowOtp(true); }}>
                        Already Have Pin
                    </Button>
                    <Button variant="contained" onClick={() => { setForgotPassword(false); setOtp({ ...otp, fetch: true }); setShowOtp(true); }}>
                        Get PIN
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showOtp} onClose={() => setShowOtp(false)} fullWidth maxWidth="xs">
                <DialogTitle>Enter One Time PIN</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <TextField
                            label="PIN"
                            type="number"
                            onChange={e => setPin(e.target.value)}
                            required
                            fullWidth
                        />
                        <DialogContentText>
                            Please enter the One Time Pin received in your email.
                        </DialogContentText>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={handleSubPin}>Verify PIN</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showChangePW} onClose={() => setShowChangePW(false)} fullWidth maxWidth="xs">
                <DialogTitle>Change Password</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <TextField
                            label="Password"
                            type="password"
                            value={pw.password}
                            onChange={e => setPw({ ...pw, password: e.target.value })}
                            required
                            fullWidth
                        />
                        <TextField
                            label="Verify Password"
                            type="password"
                            value={pw.password2}
                            onChange={e => setPw({ ...pw, password2: e.target.value })}
                            required
                            fullWidth
                        />
                        {mismatch && <Alert severity="error">Passwords do not match</Alert>}
                        <DialogContentText>Please create a new password.</DialogContentText>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" disabled={mismatch} onClick={handleChangePassword}>Submit</Button>
                </DialogActions>
            </Dialog>
        </>
    )
};

export default ForgotPassword;
